{
  "menu": "Menú de ajustes",
  "cerca": "Buscar en ajustes…",
  "senseResultats": "Ningún ajuste coincide",
  "inici": "Todos los ajustes",
  "grups": {
    "organitzacio": "Organización",
    "persones": "Personas y permisos",
    "avisos": "Avisos",
    "documentacio": "Documentación",
    "sistema": "Sistema"
  },
  "canvis": {
    "pendents_one": "{{count}} cambio sin guardar",
    "pendents_other": "{{count}} cambios sin guardar",
    "pendentsA_one": "{{count}} cambio sin guardar en «{{nom}}»",
    "pendentsA_other": "{{count}} cambios sin guardar en «{{nom}}»",
    "descarta": "Descartar",
    "desa": "Guardar",
    "desant": "Guardando…",
    "sortirTitol": "Tienes cambios sin guardar",
    "sortirText": "Si continúas, se perderán los cambios que no has guardado.",
    "sortirDescarta": "Descartar los cambios",
    "sortirContinua": "Seguir editando"
  },
  "confirma": {
    "cancella": "Cancelar"
  },
  "estructura": {
    "cerca": "Buscar departamento, área o servicio…",
    "toda": "Toda la organización",
    "departament": "Departamento",
    "area": "Área",
    "servei": "Servicio",
    "inclouFills": "Incluye todas sus áreas y servicios",
    "inclouServeis": "Incluye todos sus servicios",
    "senseResultats": "Nada coincide con «{{q}}»",
    "inactiu": "Inactivo"
  },
  "mostraInactius": "Mostrar inactivos",
  "nou": "Nuevo",
  "tanca": "Cerrar"
}
